import { useEffect, useState } from 'react';
import clsx from 'clsx';
import { toast } from 'react-toastify';
import { GetInfluencerProductRequestResponse } from '@Saral-Influencer-Marketing/saral-utils/dist/types/productRequests';
import { getProductRequestedByCreator } from '../../../../services/dashboard.service';
import styles from './alreadyRequestedProducts.module.css';
import IconContainer from '../../../common/IconContainer/IconContainer';
import useIsMobile from '../../../../hooks/useIsMobile';
import ProductSkeleton from '../ProductsPreviewSection/ProductSkeleton';
import AlreadyRequestedProductCard from './AlreadyRequestedProductCard';

interface Props {
  defaultCurrency: string;
  setShowViewProductModal: React.Dispatch<React.SetStateAction<GetInfluencerProductRequestResponse | null>>;
}

export default function AlreadyRequestedProducts({ defaultCurrency, setShowViewProductModal }: Props) {
  const [alreadyRequestedProducts, setAlreadyRequestedProducts] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const isMobile = useIsMobile();

  const fetchAlreadyRequestedProducts = async () => {
    setIsLoading(true);
    const response = await getProductRequestedByCreator();
    if (response.status) {
      setAlreadyRequestedProducts(response?.data?.data || []);
    } else {
      toast.error('Unable to get requestsO');
    }
    setIsLoading(false);
  };

  const reminderBaseCount = isMobile ? 2 : 3;

  const remainder = alreadyRequestedProducts.length % reminderBaseCount;
  let skeletonCount = 0;
  if (isLoading) {
    skeletonCount = reminderBaseCount;
  } else if (remainder !== 0) {
    skeletonCount = reminderBaseCount - remainder;
  }

  useEffect(() => {
    fetchAlreadyRequestedProducts();
  }, []);

  if (alreadyRequestedProducts.length === 0 && !isLoading) {
    return (
      <div className={styles.ftuxContainer}>
        <div className="flex flex-col w-full flex-center items-center px-6">
          <IconContainer icon="🎁" />
          <p
            className={clsx('text-xl mt-6 mb-2 font-medium text-default text-center', {
              'text-base': isMobile,
            })}
          >
            No Products Requested Yet!
          </p>
          <p className="text-sm text-subdued text-center">
            Browse available products and submit a request
            {!isMobile ? <br /> : ' '}
            to get started!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`${styles.alreadyRequestedProductsContainer} ${
        alreadyRequestedProducts?.length > 3 && styles.highProducts
      } rounded`}
    >
      {alreadyRequestedProducts.length !== 0 &&
        alreadyRequestedProducts.map((product, i) => {
          return (
            <AlreadyRequestedProductCard
              key={i}
              product={product}
              defaultCurrency={defaultCurrency}
              viewProduct={() => {
                setShowViewProductModal(null);
                setShowViewProductModal(product);
              }}
            />
          );
        })}
      {Array.from({ length: skeletonCount }, (_, index) => (
        <ProductSkeleton
          key={`skeleton-${index}`}
          color={isLoading ? 'var(--background-highlight)' : 'var(--background-default)'}
        />
      ))}
    </div>
  );
}
